import React, { useState, useEffect } from 'react'
import {
  Container,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { getNotificationsByUserId, clearNotifications, getNotificationById, notificationSeen } from '../flux/actions/notificationActions';
import Loading from './Loading';
import { INotificationPopup, INotificationPopupReduxProps } from '../types/interfaces';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell, faCheckDouble, faClock, faCog, faExclamationTriangle, faExpandAlt, faExpandArrowsAlt, faEyeSlash, faImage, faPlus, faTimes, faUser } from '@fortawesome/free-solid-svg-icons'
import { constants } from '../types/constants';
import { useHistory } from 'react-router-dom';
import { PRIVILEGE } from '../types/privileges';
import moment from "moment";
import NotificationAdd from './notification/NotificationAdd';

const NotificationPopup = ({
  getNotificationsByUserId,
  clearNotifications,
  notification,
  notificationSeen,
  user,
  auth
 }: INotificationPopup) => {
  const history = useHistory();
  const {notifications, loading} = notification
  const {users} = user
  const [notificationsList, setNotificationsList] = useState<any[]>(notifications)
  const [open, setOpen] = useState(false)
  const panelRef = React.useRef<any>(null)
  const [modalAdd, setModalAdd] = useState(false);
  const [modalZoom, setModalZoom] = useState(false);
  const [modalZoomId, setModalZoomId] = useState<any>(undefined);
  const [modalZoomData, setModalZoomData] = useState<any>(undefined);
  const [modalZoomDataLoading, setModalZoomDataLoading] = useState(false);
  
  const handleToggleZoom = () => setModalZoom(!modalZoom);

  useEffect(() => {
    setModalZoomData(undefined)
    if(modalZoomId){
      setModalZoomDataLoading(true)
      getNotificationById(modalZoomId)
        .then(e => setModalZoomData(e))
        .finally(() => setModalZoomDataLoading(false))
    }
  }, [modalZoomId])

  useEffect(() => {
    setNotificationsList(notifications.sort((a, b) => {
      if(a.id == null) return 1
      if(b.id == null) return -1
      return b.id - a.id
    }))
  }, [notifications])

  useEffect(() => {
    const handleClickOutside = e => {
      if (panelRef.current && !panelRef.current.contains(e.target))
        setOpen(false)
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])
  
  useEffect(() => {
    clearNotifications()
    if(auth?.user?.id)
      getNotificationsByUserId(auth.user.id)
  }, [auth?.user?.id])

  useEffect(() => () => clearNotifications(), [])

  const ZoomedNotification = ({data}) => {
    if(!data.notification_model)
      return null
    const typeData = constants.NOTIFICATION_TYPES.find(e => e.code === data.notification_model?.type)
    if(!typeData)
      return null
    return <Container>
      <FontAwesomeIcon icon={faTimes} style={{cursor: "pointer", position: "absolute", right: "10px", top: "10px", color: "#666"}} onClick={() => setModalZoom(false)} />
      <Row style={{display: "flex", flexDirection: "column", borderBottom: "1px solid #999", padding: "0 .5rem .3rem"}}>
        <div className="d-flex">De:&nbsp;<div style={{fontWeight: 600}}>{users.find(e => e.id === data.notification_model.createdById)?.username || "-"}</div></div>
        {!data.notification_model.hideReceivers && <div className="d-flex">À:&nbsp;<div className="maxLines max3Lines" style={{fontWeight: 600}} title={users.filter(e => data.notification_model.notifications?.find(t => t.userId === e.id)).map(e => e.username).join(", ")}>{users.filter(e => data.notification_model.notifications?.find(t => t.userId === e.id)).map(e => e.username).join(", ")}</div></div>}
      </Row>
      <Row>
        <Col sm="12">
          <div className="fullFlexCenter" style={{fontSize: "large", color: "white", borderTopLeftRadius: "8px", borderTopRightRadius: "8px", padding: "3px 8px", margin: ".5rem 0 .2rem", backgroundColor: typeData.color || "black"}}><FontAwesomeIcon icon={typeData.icon} style={{paddingRight: "4px"}} />{data.notification_model.title || typeData.label || "-"}</div>
        </Col>
      </Row>
      <Row>
        {!!data.notification_model.convertedImage && <Col sm={data.notification_model.description ? "6" : "12"}>
          <img className="zoomedNotificationImg" style={{borderColor: typeData.color || "black"}} src={`data:image/jpeg;base64,${data.notification_model.convertedImage}`} />
        </Col>}
        {!!data.notification_model.description && <Col sm={data.notification_model.convertedImage ? "6" : "12"} style={{display: "flex", alignItems: "stretch"}}>
          {/* <div className="fullFlexCenter" style={{fontSize: "large", color: "white", borderRadius: "6px", padding: "3px 8px", margin: ".5rem 0 .2rem", backgroundColor: typeData.color || "black"}}><FontAwesomeIcon icon={typeData.icon} style={{paddingRight: "4px"}} />{data.notification_model.title || typeData.label || "-"}</div> */}
          <div style={{width: "100%", borderBottomRightRadius: "8px", borderBottomLeftRadius: "8px", boxShadow: "0px 1px 30px rgba(34, 35, 58, 0.1)", padding: "8px 15px", display: "flex", alignItems: "center"}}>
            <div style={{whiteSpace: "pre-wrap", fontFamily: "Tahoma, sans-serif"}}>{data.notification_model.description}</div>
          </div>
        </Col>}
      </Row>
      <Row className="justify-content-end">
        <div className="text-muted" style={{fontSize: "small", fontStyle: "italic", marginTop: "0.5rem"}} title={moment(data.notification_model.createdAt).format('DD/MM/YYYY - HH:mm')}><FontAwesomeIcon icon={faClock} style={{marginRight: "3px"}} />Envoyée le: {moment(data.notification_model.createdAt).locale('fr').calendar({
            sameDay: '[Aujourd\'hui à] HH:mm',
            nextDay: 'DD/MM/YYYY à HH:mm',
            nextWeek: 'DD/MM/YYYY à HH:mm',
            lastDay: '[Hier à] HH:mm',
            lastWeek: 'DD/MM/YYYY à HH:mm',
            sameElse: 'DD/MM/YYYY à HH:mm'
        })}</div>
      </Row>
    </Container>
  }

  const expandNotification = n => {
    setOpen(false);
    setModalZoomId(n.id);
    setModalZoom(true);
    if(!n.seen)
      notificationSeen(n.id, 0);
  }
  
  return <>
    <div className="notification-container" ref={panelRef}>
      <div onClick={() => setOpen(!open)} className="notification-button position-relative" style={notificationsList.filter(e => !e.seen).length > 0 ? {paddingRight: ".5rem"} : {}} title={notificationsList.filter(e => !e.seen).length > 0 ? `${notificationsList.filter(e => !e.seen).length} notification${notificationsList.filter(e => !e.seen).length > 1 ? "s" : ""} non lue${notificationsList.filter(e => !e.seen).length > 1 ? "s" : ""}` : "Notifications"}>
        <FontAwesomeIcon icon={faBell} style={{fontSize: "medium"}} />
        {notificationsList.filter(e => !e.seen).length > 0 && (
          <span className="badge bg-danger position-absolute top-0 start-100 translate-middle">
            {notificationsList.filter(e => !e.seen).length}
          </span>
        )}
      </div>

      {open && (
        <div className="notification-panel position-absolute end-0 mt-2 p-2 bg-white border rounded shadow zindex-dropdown">
          <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-2">
            <strong>Notifications</strong>
            <div>
              {!!auth?.user?.privileges?.includes(PRIVILEGE.MANAGE_NOTIFICATIONS) && <button style={{background: "none", border: "none"}} onClick={e => setModalAdd(true)} title="Gestion des notifications">
                <FontAwesomeIcon icon={faPlus} />
              </button>}
              {!!auth?.user?.privileges?.includes(PRIVILEGE.MANAGE_NOTIFICATIONS) && <button style={{background: "none", border: "none"}} onClick={e => {
                  if (e.ctrlKey){
                    window.open('/notifications', '_blank');
                    return;
                  }
                  history.push({ pathname: `/notifications` })
                }} title="Gestion des notifications">
                <FontAwesomeIcon icon={faCog} />
              </button>}
              <button style={{background: "none", border: "none"}} onClick={() => setOpen(false)} title="Fermer le panneau des notifications">
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
          </div>
          <div className="notificationListContainer">
            {notificationsList.map(n => {
              if(!n.notification_model)
                return null
              const typeData = constants.NOTIFICATION_TYPES.find(e => e.code === n.notification_model?.type)
              if(!typeData)
                return null
              return <div key={n.id} className={`mb-2 p-2 rounded notificationItem${!n.seen ? " notificationItemUnread" : ""}`} style={{cursor: "pointer"}} onClick={() => expandNotification(n)}>
                <div className="notificationItemTopRightBtns">
                  {!n.seen ? <FontAwesomeIcon icon={faCheckDouble} onClick={e => {e.stopPropagation(); notificationSeen(n.id, 0)}} title="Marquer comme lue" />
                  : <FontAwesomeIcon icon={faEyeSlash} onClick={e => {e.stopPropagation(); notificationSeen(n.id, 1)}} title="Marquer comme non lue" />}
                  <FontAwesomeIcon icon={faExpandAlt} onClick={e => {e.stopPropagation(); expandNotification(n)}} title="Agrandir la notification" />
                </div>
                <div className="d-flex align-items-center">
                  <FontAwesomeIcon icon={typeData?.icon} style={{marginRight: ".5rem", fontSize: "x-large", color: typeData?.color || "black"}} />
                  <div>
                    <div>
                      <span className="notificationItemTitle" title={n.notification_model.title || typeData?.label} style={{backgroundColor: typeData?.color || "black"}}>{n.notification_model.title || typeData?.label || ""}</span>
                    </div>
                    <div className="text-muted notificationItemDescription maxLines max6Lines" title={n.notification_model.description}>{!!n.notification_model.hasImage && <FontAwesomeIcon icon={faImage} style={{marginRight: "3px", fontSize: "medium", color: "purple"}} title="Une image a été jointe à cette notification." />}{n.notification_model.description || ""}</div>
                  </div>
                </div>
                <div className="d-flex justify-content-between text-muted" style={{fontSize: "x-small", fontStyle: "italic", marginBottom: "-5px"}}>
                  <div title={`${users.find(e => e.id === n.notification_model.createdById)?.surname || ""} ${users.find(e => e.id === n.notification_model.createdById)?.given_name || ""}`}><FontAwesomeIcon icon={faUser} style={{marginRight: "3px"}} title="Envoyée par" />{users.find(e => e.id === n.notification_model.createdById)?.username || "-"}</div>
                  <div title={moment(n.notification_model.createdAt).format('DD/MM/YYYY - HH:mm')}><FontAwesomeIcon icon={faClock} style={{marginRight: "3px"}} title="Envoyée le" />{moment(n.notification_model.createdAt).locale('fr').calendar({
                      sameDay: '[Aujourd\'hui à] HH:mm',
                      nextDay: 'DD/MM/YYYY à HH:mm',
                      nextWeek: 'DD/MM/YYYY à HH:mm',
                      lastDay: '[Hier à] HH:mm',
                      lastWeek: 'DD/MM/YYYY à HH:mm',
                      sameElse: 'DD/MM/YYYY à HH:mm'
                  })}</div>
                </div>
              </div>
            })}
            {notificationsList.length === 0 && <div className="text-muted small">Aucune notification</div>}
          </div>
        </div>
      )}
    </div>
    <Modal isOpen={modalZoom} toggle={handleToggleZoom} className="modal-dialog-extra-large">
      {/* <ModalHeader toggle={handleToggleZoom}><FontAwesomeIcon icon={faBell} />&nbsp;&nbsp;Notification</ModalHeader> */}
      <ModalBody>
        {modalZoomDataLoading ? <Loading /> : <ZoomedNotification data={modalZoomData} />}
      </ModalBody>
    </Modal>
    <NotificationAdd modal={modalAdd} setModal={setModalAdd} />
  </>
}

const mapStateToProps = (state: INotificationPopupReduxProps) => ({
  notification: state.notification,
  user: state.user,
  auth: state.auth,
  error: state.error
});

export default connect(mapStateToProps, {getNotificationsByUserId, clearNotifications, notificationSeen})(NotificationPopup);